module.exports = __webpack_public_path__ + "img/icon-eye-tab.19d91994.png";